import { useEffect, useRef } from 'react';
import SiteLayout from '../../components/common/SiteLayout';
import usePageMeta from '../../components/common/usePageMeta';

const SNIPPET = '/cancellation-calculator.html';
const META = { path: '/cancellation-calculator/', metaTitle: 'Cancellation Calculator | 440 Artists', description: null, noindex: true };

export default function CancellationCalculator() {
    const ref = useRef(null);

    usePageMeta(META);

    useEffect(() => {
        let cancelled = false;
        fetch(SNIPPET)
            .then((res) => res.text())
            .then((html) => {
                if (cancelled) return;
                ref.current.innerHTML = html;
                ref.current.querySelectorAll('script').forEach((old) => {
                    const script = document.createElement('script');
                    script.textContent = old.textContent;
                    old.replaceWith(script);
                });
            });
        return () => { cancelled = true; };
    }, []);

    return (
        <SiteLayout headerVariant="full" mainClassName="bg-[#f6f7f5]">
            <div ref={ref} />
        </SiteLayout>
    );
}
